import { Flex, Button, useTheme, View, Text } from '@aws-amplify/ui-react';

import { LoginButton } from '../components/auth/LoginButton'

const myStyle = {
  color: "white",
  //backgroundColor: "silver",
  fontFamily: "Sans-Serif",
  alignItems: "stretch",
  alignContent: "flex-end"
};


const DefaultFlexExample = () => {
  const { tokens } = useTheme();

  return (
    <Flex style={myStyle}>
      <Text
        variation="secondary"
        as="p"
        lineHeight="1.5em"
        fontWeight={750}
        fontSize="1.5em"
        fontStyle="normal"
        textDecoration="none"
        width="30vw"
      >
       Youtube Video Inspector
      </Text>

      {/* <Button backgroundColor={tokens.colors.pink[10]}>Option 1</Button>
      <Button backgroundColor={tokens.colors.pink[20]}>Option 2</Button> */}
{/* 
      <View style={{ marginLeft: 'auto' }} >
        <LoginButton></LoginButton>
      </View> */}
    </Flex>
  );
};


export default DefaultFlexExample;